import { Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { useEffect, useState } from "react";
import GlobalLeftBar from "../../components/organisms/navigation/GlobalLeftBar";
import CustomView from "../../components/organisms/tickets/CustomView";
import MyList from "../../components/organisms/tickets/MyList";
import NotClosedList from "../../components/organisms/tickets/NotClosedList";
import RecentClosedList from "../../components/organisms/tickets/RecentClosedList";
import Search from "../../components/organisms/tickets/Search";
import UnAssignedList from "../../components/organisms/tickets/UnAssignedList";
import { useConditionUnits } from "../../hooks/conditionUnitHooks";
import { useTicketFields } from '../../hooks/ticketFieldHooks';
import { useNotClosedTicketsSnapshot } from "../../hooks/ticketHooks";
import { buildConditionTreeMap } from "../../lib/ticket";

const Index = () => {

  const fields = useTicketFields()
  useNotClosedTicketsSnapshot(fields);
  const [conditionUnits, setConditionUnits] = useConditionUnits()
  const [built, setBuilt] = useState([])
  useEffect(() => {
    const built = buildConditionTreeMap(conditionUnits)
    setBuilt(built)
  }, [conditionUnits]);

  return (
    <div className="flex w-screen h-screen">
      <GlobalLeftBar active="ticket" />
      <Tabs
        defaultIndex={2}
        display={"flex"}
        className="w-[calc(100%-5rem)]"
      >
        <TabList
          flexDirection={"column"}
          className="w-2/12 border-r border-gray-200 flex flex-col"
        >
          <Tab textAlign={"left"} fontSize={"xl"} justifyContent={"left"} className={`text-xl pl-10 m-5 p-5 mt-20 cursor-pointer`}>
            完了したお問い合せの検索
          </Tab>
          <Tab textAlign={"left"} fontSize={"xl"} justifyContent={"left"} className={`text-xl pl-10 m-5 p-5 cursor-pointer`}>
            本日完了のお問い合せ
          </Tab>
          <Tab textAlign={"left"} fontSize={"xl"} justifyContent={"left"} className={`text-2xl pl-10 m-5 p-5 mt-20 cursor-pointer`}>
            私のお問い合せ
          </Tab>
          <Tab textAlign={"left"} fontSize={"xl"} justifyContent={"left"} className={`text-2xl pl-10 m-5 p-5 cursor-pointer`}>
            未完了のお問い合せ
          </Tab>
          <Tab textAlign={"left"} fontSize={"xl"} justifyContent={"left"} className={`text-2xl pl-10 m-5 p-5 cursor-pointer`}>
            未割り当てのお問い合せ
          </Tab>
          { built?.map((unit) => {
            return (
              <Tab textAlign={"left"} fontSize={"xl"} justifyContent={"left"} key={unit.id} className={`text-2xl pl-10 m-5 p-5 cursor-pointer`}>
                {unit.name || "名前が設定されていません"}
              </Tab>
            )
          }) }
          { !built?.length && <Text justifyContent={"left"} className="text-xl m-10">カスタムビューがありません</Text> }
        </TabList>
        <TabPanels className="w-10/12 p-10 pt-0 overflow-y-auto h-full">
          <TabPanel>
            <Search />
          </TabPanel>
          <TabPanel>
            <RecentClosedList />
          </TabPanel>
          <TabPanel>
            <MyList />
          </TabPanel>
          <TabPanel>
            <NotClosedList />
          </TabPanel>
          <TabPanel>
            <UnAssignedList />
          </TabPanel>
          { built?.map((unit) => {
            return (
              <TabPanel key={unit.id}>
                <CustomView built={unit} />
              </TabPanel>
            )
          }) }
        </TabPanels>
      </Tabs>
    </div>
  );
};

export default Index;
